import React from "react";
import PropTypes from "prop-types";
import DomainStatusBadge from "Components/domainStatusBadge/DomainStatusBadge";
import DropdownMenu from "react-dd-menu";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import { Icon, trash, more, enable, disable } from "Icons/index";
import { withRouter } from "react-router-dom";
import t from "Utils/translation";

const ContextTypes = {
  getLoggedUser: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

class EmailAccountRow extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
    this.showEmail = this.showEmail.bind(this);
    this.deleteEmail = this.deleteEmail.bind(this);
    this.state = {
      isMenuOpen: false,
    };
  }

  toggle() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  }

  close() {
    this.setState({ isMenuOpen: false });
  }

  showEmail() {
    const {
      location: { search },
      emailAccount,
    } = this.props;
    this.props.history.push({
      pathname: `/archive/domains/${emailAccount.domain_code}/email_accounts/${emailAccount.code}`,
      state: {
        prevPagination: search,
      },
    });
  }

  deleteEmail() {
    this.props.deleteEmail(this.props.emailAccount);
  }

  render() {
    const { emailAccount: ea } = this.props;
    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;
    const loggedUser = this.context.getLoggedUser();

    let showMenu = true;
    let canChangeStatus = true;
    let canDelete = true;
    if (loggedUser.type === "TeamMember" && !loggedUser.permissions.includes("delete_vault_email_accounts")) {
      canDelete = false;
    }

    if (loggedUser.type === "TeamMember" && !loggedUser.permissions.includes("disable_vault_email_accounts")) {
      canChangeStatus = false;
    }

    if (!canChangeStatus && !canDelete) showMenu = false;

    let changeStatusButton;
    if (ea.archive_status === "enabled" && canChangeStatus) {
      changeStatusButton = (
        <li>
          <a onClick={() => this.props.toggleStatus("disabled")}>
            <Icon svg={disable} />
            <div>{t("ddMenu.disable")}</div>
          </a>
        </li>
      );
    } else if (ea.archive_status === "disabled" && canChangeStatus) {
      changeStatusButton = (
        <li>
          <a onClick={() => this.props.toggleStatus("enabled")}>
            <Icon svg={enable} />
            <div>{t("ddMenu.enable")}</div>
          </a>
        </li>
      );
    }

    const isLoading = ea.archive_status === "activating" || ea.status === "updating";

    return (
      <tr key={ea.code}>
        <td data-label={t("table.header.status")}>
          {isLoading ? (
            <DomainStatusBadge status={ea.status} statusDetail={ea.archive_status} archive />
          ) : (
            <DomainStatusBadge status={ea.archive_status} statusDetail={ea.archive_status} archive />
          )}
        </td>
        <td data-label={t("table.header.account")} className="textOverflow">
          {ea.archive_status === "disabled" || ea.status === "updating" ? (
            ea.email_address
          ) : (
            <a onClick={this.showEmail}>{ea.email_address}</a>
          )}
        </td>
        <td data-label={t("table.header.retention")} className="hideOnMobile">
          {ea.retention}
        </td>
        <td data-label={t("table.header.delegates")}>{ea.delegates_no || 0}</td>
        <td>
          {!isLoading && (
            <DropdownMenu
              isOpen={this.state.isMenuOpen}
              animate={false}
              close={this.close}
              toggle={showMenu ? <ButtonIcon icon={more} onClick={() => this.toggle(ea.code)} /> : ""}
              align="right"
            >
              {changeStatusButton}
              {canDelete && (
                <li>
                  <a onClick={this.deleteEmail}>
                    <Icon svg={trash} />
                    <div>{t("ddMenu.delete")}</div>
                  </a>
                </li>
              )}

              {isMediaMobile() && (
                <li className="cancelBtn">
                  <a>
                    <div>{t("ddMenu.cancel")}</div>
                  </a>
                </li>
              )}
            </DropdownMenu>
          )}
        </td>
      </tr>
    );
  }
}

EmailAccountRow.contextTypes = ContextTypes;

export default withRouter(EmailAccountRow);
